var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLabelCreated = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 9 16 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 22V9h15.999v13zm5.999-7.999h9V10h-9zM12 20v-4h1v4zm2 0v-4h1.001v4zm6 0v-4h1v4zM9 20v-4h2v4zm7 0v-4h2.999v4zm-8 1h13.999v-5.999H8z"
})));
export default SvgLabelCreated;